import { BaseSanitizer } from './BaseSanitizer';
export class DeviceIdSanitizer extends BaseSanitizer {
    constructor(context, enabled = true) {
        super(context, 'DEVICE_ID', 'deviceIds', enabled);
    }
    detectMatches(text) {
        const matches = [];
        const imeiMatches = this.detectIMEI(text);
        const udidMatches = this.detectUDID(text);
        const idfaMatches = this.detectIDFA(text);
        matches.push(...imeiMatches, ...udidMatches, ...idfaMatches);
        return this.removeOverlappingMatches(matches);
    }
    detectIMEI(text) {
        const matches = [];
        const patterns = [
            /\b\d{2}[-\s]?\d{6}[-\s]?\d{6}[-\s]?\d\b/g, // AA-BBBBBB-CCCCCC-D
            /\b\d{15}\b/g // Continuous 15 digits
        ];
        for (const pattern of patterns) {
            let match;
            while ((match = pattern.exec(text)) !== null) {
                const imei = match[0].replace(/[-\s]/g, '');
                if (this.isValidIMEI(imei)) {
                    matches.push({
                        originalText: match[0],
                        tag: '',
                        startIndex: match.index,
                        endIndex: match.index + match[0].length
                    });
                }
            }
        }
        return matches;
    }
    detectUDID(text) {
        const matches = [];
        const udidPattern = /\b[a-f0-9]{40}\b/gi;
        let match;
        while ((match = udidPattern.exec(text)) !== null) {
            if (this.looksLikeUDIDContext(text, match.index)) {
                matches.push({
                    originalText: match[0],
                    tag: '',
                    startIndex: match.index,
                    endIndex: match.index + match[0].length
                });
            }
        }
        return matches;
    }
    detectIDFA(text) {
        const matches = [];
        const idfaPattern = /\b[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\b/gi;
        let match;
        while ((match = idfaPattern.exec(text)) !== null) {
            matches.push({
                originalText: match[0],
                tag: '',
                startIndex: match.index,
                endIndex: match.index + match[0].length
            });
        }
        return matches;
    }
    isValidIMEI(imei) {
        if (imei.length !== 15 || !/^\d+$/.test(imei)) {
            return false;
        }
        return this.luhnCheck(imei);
    }
    luhnCheck(number) {
        let sum = 0;
        let isEven = false;
        for (let i = number.length - 1; i >= 0; i--) {
            let digit = parseInt(number[i], 10);
            if (isEven) {
                digit *= 2;
                if (digit > 9) {
                    digit -= 9;
                }
            }
            sum += digit;
            isEven = !isEven;
        }
        return sum % 10 === 0;
    }
    looksLikeUDIDContext(text, index) {
        const before = text.substring(Math.max(0, index - 20), index).toLowerCase();
        const after = text.substring(index, Math.min(text.length, index + 10)).toLowerCase();
        const keywords = ['udid', 'device', 'identifier', 'ios', 'iphone', 'ipad', 'unique', 'mobile'];
        return keywords.some(keyword => before.includes(keyword) || after.includes(keyword));
    }
}
